var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderCollateral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.5,
    height: 65.5,
    viewBox: "0 0 65.5 65.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OrderCollateral_Icon",
    "data-name": "OrderCollateral Icon",
    transform: "translate(-17.669 -17.719)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(18.72 18.777)",
    fill: "#e8f2f2",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(18.419 18.469)",
    fill: "#fff",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2679",
    "data-name": "Group 2679",
    transform: "translate(33.504 32.465)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_665",
    "data-name": "Rectangle 665",
    width: 8.116,
    height: 10.863,
    transform: "translate(3.295 3.959)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_666",
    "data-name": "Rectangle 666",
    width: 7.091,
    height: 1.602,
    transform: "translate(3.983 23.645)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_667",
    "data-name": "Rectangle 667",
    width: 7.091,
    height: 1.602,
    transform: "translate(3.964 20.287)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_668",
    "data-name": "Rectangle 668",
    width: 7.086,
    height: 1.602,
    transform: "translate(3.916 16.92)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M75.551,47.776H64.419v-4.4a1.677,1.677,0,0,0-.534-1.227.9.9,0,0,0-.1-.135.8.8,0,0,0-.548-.25,1.607,1.607,0,0,0-.505-.077H45.06a1.653,1.653,0,0,0-1.65,1.65V69.463a2.156,2.156,0,0,0,2.15,2.15h9.886v3.935A2.153,2.153,0,0,0,57.6,77.7H75.551a1.691,1.691,0,0,0,1.689-1.689V49.469a1.688,1.688,0,0,0-1.689-1.689ZM59.079,67.6H73.9v1.6H59.079Zm-.106-1.766v-1.6H73.791v1.6Zm.14,5.128H73.93v1.6H59.113v-1.6ZM58.872,62.2V52.409H74.046V62.2Zm-.034-14.423,3.979-3.748v3.748ZM45.56,70.012a.548.548,0,0,1-.548-.548V43.34a.048.048,0,0,1,.048-.048h16.2l-4.9,4.614a.962.962,0,0,0-.067.077,1.652,1.652,0,0,0-.852,1.443V70.012Z",
    transform: "translate(-43.41 -41.69)",
    fill: "#a5551c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderCollateral);
export default __webpack_public_path__ + "static/media/OrderCollateral.971d7a2c4a9cedf821e6c3b7bc35eaf2.svg";
export { ForwardRef as ReactComponent };